// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"BaseInfo--next-sr-only--2DTA-h5","base-info-container":"BaseInfo--base-info-container--3J7NAS-"};